import Paciente from '@/views/pages/cadastros/paciente/Paciente'
import PacienteListagem from '@/views/pages/cadastros/paciente/listagem/PacienteListagem'
import PacienteDadosGeraisCadastro from '@/views/pages/cadastros/paciente/cadastro/PacienteDadosGeraisCadastro'
import PacienteDadosGeraisEdicao from '@/views/pages/cadastros/paciente/edicao/PacienteDadosGeraisEdicao'
import PacienteComum from '@/views/pages/cadastros/paciente/comum/PacienteComum'
import PacienteFicha from '@/views/pages/cadastros/paciente/comum/ficha/PacienteFicha.vue'
import Odontograma from '@/views/pages/cadastros/paciente/comum/odontograma/Odontograma.vue'
import PacienteFichaOrcamento from '@/views/pages/cadastros/paciente/comum/orcamento/PacienteFichaOrcamento.vue'
import PacienteFichaCobrancas from '@/views/pages/cadastros/paciente/comum/cobrancas/PacienteFichaCobrancas.vue'
import PacienteGaleria from '@/views/pages/cadastros/paciente/comum/galeria/PacienteGaleria.vue'
import EnviarFotoPorQRCodePaciente
from '@/views/pages/cadastros/paciente/comum/galeria/EnviarFotoPorQRCodePaciente.vue'

export default [
    {
        path: '/pacientes',
        name: 'PacienteListagem',
        component: PacienteListagem,
        meta: {
            requiresAuth: true,
            page: {
                title: 'Pacientes',
                subtitle: 'Lista geral pacientes'
            }
        }
    },
    {
        path: '/public/paciente/enviar-foto-galeria/:token',
        name: 'EnviarFotoPorQRCodePaciente',
        component: EnviarFotoPorQRCodePaciente,
        meta: {
            requiresAuth: false,
            independente: true
        }
    },
    {
        path: '/paciente',
        name: 'Paciente',
        component: Paciente,
        children: [
            {
                path: '/paciente/cadastro',
                name: 'PacienteCadastro',
                component: PacienteDadosGeraisCadastro,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Paciente',
                        subtitle: 'Cadastro de Paciente'
                    },
                    perfis: ['ADMINISTRADOR', 'PACIENTE_CADASTRAR'],
                }
            },
            {
                path: '/paciente/:id/edicao',
                name: 'PacienteEdicao',
                component: PacienteDadosGeraisEdicao,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Paciente',
                        subtitle: 'Edição de Paciente'
                    },
                    perfis: ['ADMINISTRADOR', 'PACIENTE_ATUALIZAR'],
                }
            }
        ]
    },
    {
        path: '/paciente',
        name: 'PacienteDetalhes',
        component: PacienteComum,
        redirect: '/paciente/:id/ficha',
        children: [
            {
                path: '/paciente/:id/ficha',
                name: 'PacienteFicha',
                component: PacienteFicha,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Paciente',
                        subtitle: 'Ficha'
                    },
                }
            },
            {
                path: '/paciente/:id/atendimentos',
                name: 'PacienteAtendimento',
                component: Odontograma,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Paciente',
                        subtitle: 'Atendimentos'
                    },
                }
            },
            {
                path: '/paciente/:id/orcamentos',
                name: 'PacienteOrcamento',
                component: PacienteFichaOrcamento,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Paciente',
                        subtitle: 'Orçamentos'
                    },
                }
            },
            {
                path: '/paciente/:id/cobrancas',
                name: 'PacienteCobrancas',
                component: PacienteFichaCobrancas,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Paciente',
                        subtitle: 'Cobranças'
                    },
                }
            },
            {
                path: '/paciente/:id/galeria',
                name: 'PacienteGaleria',
                component: PacienteGaleria,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Paciente',
                        subtitle: 'Galeria'
                    },
                }
            },
        ]
    }
]